import { MultiCourseCompetitionService } from 'services/multi-course-competition-service/multi-course-competition.service';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as global from 'src/globals';
import * as moment from 'moment';
import { Hotel, HotelRoom, PackageStayOption, StayAndPlayPackage } from 'src/data/mygolf.data';
import { ImageZoomPage } from '../image-zoom/image-zoom.page';

@Component({
  selector: 'app-hotel-details',
  templateUrl: './hotel-details.component.html',
  styleUrls: ['./hotel-details.component.scss'],
})
export class HotelDetailsComponent implements OnInit {
  slideOpts = {
    slidesPerView: 1,
    speed: 400,
    spaceBetween: 0,
  };

  @Input() hotelDetails: any;
  @Input() packageDetails: StayAndPlayPackage;
  @Input() groupedStayOptions: Array<PackageStayOption>;
  longitude: string | number;
  latitude: string | number;
  mapsQuery: string = '';
  @Input() infoOnly: boolean = false;
  @Input() headerTitle: string;
  @Input() mode: string;
  @Input() showHotelInfo: boolean = false;
  constructor(
    private modalCtl: ModalController,
    private multiCourseCompService: MultiCourseCompetitionService
  ) {}

  ngOnInit() {
    this.getSanitizedUrl();
    console.log('Hotel Details : ', this.hotelDetails);
  }

  back() {
    this.modalCtl.dismiss();
  }

  getImageSrc(imgSrc: string) {
    return global.MygolfServer + '/' + imgSrc;
  }

  getRoom(data: HotelRoom, value: string) {
    switch (value) {
      case 'roomName':
        return data?.roomName;
      case 'minOccupancy':
        return data?.minOccupancy;
      case 'maxOccupancy':
        return data?.maxOccupancy;
      case 'specification':
        return data?.roomSpecification;
      default:
        break;
    }
  }

  getSanitizedUrl() {
    const gpsLocation = this.hotelDetails?.hotel?.gpsLocation;
    if (gpsLocation) {
      this.latitude = gpsLocation.split(',')[0];
      this.longitude = gpsLocation.split(',')[1];
      this.mapsQuery = `${this.latitude},${this.longitude}`;
    } else {
      this.mapsQuery = `${this.hotelDetails?.hotel?.name}, ${this.hotelDetails?.hotel?.address?.state}, ${this.hotelDetails?.hotel?.address?.countryData?.name}`;
    }
  }

  backMethod(data: string) {
    this.modalCtl.dismiss(data);
  }

  getHotelDetails(attribute?: string) {
    if (!this.hotelDetails) return;
    let _hotel: Hotel = this.hotelDetails?.hotel;

    switch (attribute) {
      case 'checkInTime':
        return moment(_hotel?.checkinTime, 'HH:mm:ss').format('HH:mm A');
      case 'checkOutTime':
        return moment(_hotel?.checkoutTime, 'HH:mm:ss').format('HH:mm A');
    }
  }

  async onClickImageZoom(imageUrl?: string) {
    const _description = '';
    let _image = imageUrl;

    console.debug('on click image zoom : ', imageUrl);

    const modal: any = await this.modalCtl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: _image,
        description: _description,
        descTopDown: 'top',
      },
    });
    await modal.present();
  }

  onToggleHotelInfo() {
    this.showHotelInfo = !this.showHotelInfo;
  }

  onSelectHotelRoom(room) {
    this.multiCourseCompService.setSelectedHotelRoom({
      hotel: this.hotelDetails,
      room: room,
    });
    this.modalCtl.dismiss(true);
  }

  parseDate(date: any) {
    return moment(date).format('dddd, DD MMM YYYY');
  }
}
